import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../layouts";
import { useAlumniStore } from "../../store";

export default function Completion() {
  const navigate = useNavigate();
  const store = useAlumniStore();

  useEffect(() => {
    if (!store.ref) {
      navigate("/alumni");
      return;
    }
  }, [navigate, store.ref]);

  useEffect(() => {
    store.clearForm();
  }, []);

  const leaveApp = () => {
    store.clearForm();
    navigate("/alumni");
  };

  return (
    <Layout mType="alumni">
      <div className="bg-gray-100">
        <div className="container mx-auto">
          <div className="lg:py-5 lg:px-0 px-0 py-4">
            <ul className="form-steps">
              <li className="active">Declaration</li>
              <li className="active">Form</li>
              <li className="active">Confirmation</li>
              <li className="active">Completion</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container mx-auto">
        <div className="lg:py-8 lg:px-0 px-4 py-4">
          <div className="flex flex-col items-center justify-center">
            <svg
              class="w-24 h-24 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            <h3 className="text-lg font-bold">Application received</h3>
            <p>
              Your application reference:{" "}
              <span className="text-blue-600 font-bold">
                {store.ref}
              </span>
            </p>
          </div>

          <div className="max-w-xl mx-auto mt-5 space-y-5">
            <div>
              <h3 className="font-bold mb-3">What happens next</h3>
              <ul className="list-disc space-y-2 ml-5">
                <li>
                  You could be asked for providing more documents and
                  information if the information you provided is not sufficient.
                </li>
                <li>
                  A payment link shall be sent to you if there is any amount due
                  in your application.
                </li>
                <li>
                  Library reserves the right of final decision on the
                  eligibility of your application.
                </li>
                <li>
                  Use the above application reference to keep track of your
                  application status. For assistance, please contact us by
                  e-mail{" "}
                  <a
                    href="mailto:libmember@eduhk.hk"
                    className="text-orange-600 hover:text-orange-700 underline"
                  >
                    libmember@eduhk.hk
                  </a>
                  .
                </li>
              </ul>
            </div>
            <div className="flex items-center justify-center">
              <button
                className="border border-orange-600 rounded-full px-5 py-3 text-center bg-orange-600 text-white hover:bg-orange-700 transition duration-200 focus:outline-none inline-flex items-center"
                onClick={leaveApp}
              >
                <svg
                  className="w-5 h-5 mr-1"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                  ></path>
                </svg>
                Return to Home Page
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
